import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {CustomStoreFinderSearchPage} from "../models/store-finder.model";
import {CustomStoreFinderAdapter} from "./custom-store-finder.adapter";

@Injectable({ providedIn: 'root' })
export class CustomStoreFinderConnector {
  constructor(protected adapter: CustomStoreFinderAdapter) {}

  search(): Observable<CustomStoreFinderSearchPage> {
    return this.adapter.search();
  }
}
